const KEYS = {
  // MESSAGES
  LOGIN_SUCESS: 'Successfully Logged In',
  ERROR_OCCURED_TRY_AGAIN: 'Error occured. Please try again',
  ENTER_OTP_AGAIN: 'Please enter the valid otp',
  WELCOME_TO_HARSHBERGER: 'Welcome to the Harshberger Portal',

  COMPANY_NAME: 'Company Name',
  COMMON_NAME_REQUIRED: 'Company name is required',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVAILD: 'Invalid email address',
  SPACE_NOT_ALLOWED: 'Space is not allowed',
  ENTER_EMAILS: 'Enter your email',
  PWD_REQUIRED: 'Password is required',
  EMAIL_ENTER: 'Enter your password',
  PROFILE_UPDATED: 'Profile updated successfully',
  EMAIL_ALREADY_EXIST: 'Email you entered is already exist',

};
export default KEYS;
